<template lang="pug">
  v-menu(v-bind="mergedAttrs" v-on="$listeners")
    template(v-slot:activator="{ on, attrs }")
      slot(name="activator" :on="on" :attrs="attrs")
    slot
</template>

<script>
export default {
  name: 'YzMenu',
  inheritAttrs: false,
  computed: {
    mergedAttrs() {
      // eslint-disable-next-line no-unused-vars
      const { rounded, ...attrs } = this.$attrs
      return {
        ...attrs,
        contentClass: `yz-menu-content ${this.$attrs.contentClass || ''}`
      }
    }
  }
}
</script>

<style lang="scss">
.yz-menu-content {
  border-radius: 8px;
}
</style>